import { AnimatePresence,motion } from "framer-motion";

const FramerFade = ({children,isActive,delay}) => {
    const style = {
        padding:'1rem',
    }
    return (
        <AnimatePresence>
            {isActive && (
                <motion.div
                    style={{padding:'1rem'}}
                    initial={{ opacity: 0, x: "100%" }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                        ease: "linear",
                        duration: 0.3,
                        type: "spring",
                        stiffness: 50,
                        delay: delay
                    }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default FramerFade